<template>
  <div>
    <el-form :inline="true" style="margin-bottom: 20px;">
      <el-form-item>
        <el-input
          v-model="searchForm.projectName"
          placeholder="项目名称"
          clearable
          style="width: 200px"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchForm.contributorName"
          placeholder="贡献人名称"
          clearable
          style="width: 200px"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.templateStatus" placeholder="模板状态" style="width: 150px" clearable>
          <el-option label="显示" value="1"></el-option>
          <el-option label="隐藏" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="projectDate"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="getTemplateProjectList">搜索</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe>
      <el-table-column
        prop="projectName"
        label="项目名称"
        width="200">
      </el-table-column>
      <el-table-column
        prop="projectDescribe"
        label="项目描述"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="contributorName"
        label="贡献人"
        width="150">
      </el-table-column>
      <el-table-column
        prop="contributeTime"
        width="180"
        label="贡献时间">
      </el-table-column>
      <el-table-column
        label="包含内容"
        width="200">
        <template slot-scope="scope">
          <span>角色: {{ scope.row.personaNum || 0 }}</span>
          <span style="margin-left: 10px;">地图: {{ scope.row.journeyMapNum || 0 }}</span>
          <span style="margin-left: 10px;">问卷: {{ scope.row.experQuestesNum || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="templateStatusDesc"
        label="模板状态"
        width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.templateStatus == 1" type="success">显示</el-tag>
          <el-tag v-else-if="scope.row.templateStatus == 2" type="info">隐藏</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        width="180"
        label="创建时间">
      </el-table-column>
      <el-table-column
        label="操作"
        width="150"
        fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleEdit(scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="page.current"
      :page-size="page.size"
      :total="page.total"
      style="margin-top: 20px; float: right;">
    </el-pagination>

    <!-- 编辑对话框 -->
    <el-dialog
      title="编辑模板项目"
      :visible.sync="editDialogVisible"
      width="600px">
      <el-form :model="editForm" label-width="100px" ref="editForm">
        <el-form-item label="项目名称" prop="projectName">
          <el-input v-model="editForm.projectName" placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item label="项目描述" prop="projectDescribe">
          <el-input
            v-model="editForm.projectDescribe"
            type="textarea"
            :rows="4"
            placeholder="请输入项目描述">
          </el-input>
        </el-form-item>
        <el-form-item label="模板状态" prop="templateStatus">
          <el-radio-group v-model="editForm.templateStatus">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="2">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "TemplateProject",
  data() {
    return {
      searchForm: {},
      projectDate: [],
      tableData: [],
      page: {
        total: 0,
        size: 10,
        current: 1,
      },
      editDialogVisible: false,
      editForm: {
        id: null,
        projectName: '',
        projectDescribe: '',
        templateStatus: 1
      }
    }
  },
  created() {
    this.getTemplateProjectList()
  },
  methods: {
    handleSizeChange(val) {
      this.page.size = val
      this.getTemplateProjectList()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.getTemplateProjectList()
    },
    getTemplateProjectList() {
      this.$axios.post("/uxm/template-project/list", {
        projectName: this.searchForm.projectName,
        contributorName: this.searchForm.contributorName,
        templateStatus: this.searchForm.templateStatus ? parseInt(this.searchForm.templateStatus) : null,
        startDate: this.projectDate === null || this.projectDate.length === 0 ? null : this.projectDate[0],
        endDate: this.projectDate === null || this.projectDate.length === 0 ? null : this.projectDate[1],
        current: this.page.current,
        size: this.page.size,
      }).then(res => {
        if (res && res.data && res.data.data) {
          this.tableData = res.data.data.records || []
          this.page.size = res.data.data.size || 10
          this.page.current = res.data.data.current || 1
          this.page.total = res.data.data.total || 0
        } else {
          this.tableData = []
          this.page.total = 0
        }
      }).catch(error => {
        console.error('获取模板项目列表失败:', error)
        this.tableData = []
        this.page.total = 0
      })
    },
    handleEdit(row) {
      this.$axios.get(`/uxm/template-project/detail/${row.id}`).then(res => {
        if (res && res.data && res.data.data) {
          this.editForm = {
            id: res.data.data.id,
            projectName: res.data.data.projectName,
            projectDescribe: res.data.data.projectDescribe,
            templateStatus: res.data.data.templateStatus
          }
          this.editDialogVisible = true
        }
      }).catch(error => {
        console.error('获取模板项目详情失败:', error)
        this.$message.error('获取模板项目详情失败')
      })
    },
    submitEdit() {
      this.$axios.post("/uxm/template-project/update", this.editForm).then(res => {
        this.$message({
          type: 'success',
          message: '更新成功'
        })
        this.editDialogVisible = false
        this.getTemplateProjectList()
      }).catch(error => {
        console.error('更新失败:', error)
        // axios拦截器已经显示了错误信息，这里不需要再次显示
        // 但如果需要，可以使用error.message获取具体错误信息
        // this.$message.error(error.message || '更新失败')
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除该模板项目吗？删除后将无法恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(`/uxm/template-project/delete/${row.id}`).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.getTemplateProjectList()
        }).catch(error => {
          console.error('删除失败:', error)
          // axios拦截器已经显示了错误信息，这里不需要再次显示
          // 但如果需要，可以使用error.message获取具体错误信息
          // this.$message.error(error.message || '删除失败')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style scoped>
.el-pagination {
  float: right;
  margin-top: 22px;
}
</style>

